<div class="end-transport-pause-dialog">

  <div class="dialog-layout">

    <h2 class="dialog-h2">
      <sc-dictionary-label dictionaryKey="tmc.visit.overview.end-transport-pause-dialog.title"></sc-dictionary-label>
    </h2>


    <div class="top-info">
      <app-transport-info-panel [carrier]="data.carrier" [identifier]="data.identifier" [driver]="data.name"
        [scope]="data.transportScope"></app-transport-info-panel>
    </div>

    <div class="dialog-content">
      <sc-dictionary-label dictionaryKey="tmc.visit.overview.end-transport-paus.confirm-text"></sc-dictionary-label>
      <app-service-response [responseMessages]="responseMessages"></app-service-response>
    </div>


    <sc-actionbar>
      <sc-content-spacer grow></sc-content-spacer>
      <sc-no-button class="cancel-button" mat-dialog-close dictionaryKey="shared.confirm-dialog.action.no"></sc-no-button>
      <sc-content-spacer></sc-content-spacer>
      <button mat-flat-button class="confirm-button" (click)="confirm()">
        <sc-dictionary-label dictionaryKey="tmc.visit.overview.end-transport-pause-dialog.button.end"></sc-dictionary-label>
      </button>
    </sc-actionbar>
  </div>

</div>
